<template>
  <div class="bear-container">
    <div class="test-btn" v-if="($store.state.debug || $store.state.debugWeather) && $store.state.displayDebug"
         @click="$store.commit('TOGGLE_DAY_MODE')">TOGGLE DAY/NIGHT
    </div>
    <div class="slides-content">
      <transition
        name="side"
        :duration="800"
        class="carousel"
        mode="out-in"
        tag="div">
        <div class="slide-content" :class="loadClass" :key="$store.state.activeSlide"
             v-if="!$store.state.preload && !$store.state.bearExit">
          <div v-for="(donor, index) in $store.getters.activeSlide.babies" :key="index"
               :class="`bear${index + 1}-container`"
               class="bear-container">
            <bear-donor :name="donor.firstname + ' ' +mName(donor.middlename) + ' ' + donor.lastname" :bear="index + 1"
                        :paw="donor.baby_theme" :position="index + 1"/>
          </div>
        </div>
      </transition>
    </div>
    <img class="labour-love" src="@/assets/images/labour-love.svg">
  </div>
</template>

<script>
import Leaves from './Background/Leaves.vue'
import BearDonor from './DonorSlide/BearDonor.vue'
import { TimelineMax } from 'gsap/TweenMax'

export default {
  name: 'DonorSlide',
  components: { Leaves, BearDonor },
  data () {
    return {
      tlBg: new TimelineMax(),
      loadClass: 'load-enter'
    }
  },
  mounted () {
    this.loadClass = ''
  },
  beforeDestroy () {
    this.tlBg.kill()
  },
  methods: {
    mName (m) {
      return m == null ? '' : m
    }
  }
}
</script>

<style>
  .slides-content {
    position: absolute;
    z-index: 3;
    bottom: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }

  .slide {
    position: absolute;
    bottom: 0px;
    display: block !important;
  }

  .slide-content {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  .bear1-container {
    position: absolute;
    bottom: -3vh;
    left: 7vw;
  }

  .bear2-container {
    position: absolute;
    bottom: 7vh;
    left: 28vw;
  }

  .bear3-container {
    position: absolute;
    bottom: 4vh;
    right: 25vw;
  }

  .bear4-container {
    position: absolute;
    bottom: 11vh;
    right: 6vw;
  }

  .bear-container {
    transition: all 1.5s ease-in-out;
  }

  .side-enter-active .bear-container {
    transition-delay: 1.5s;
    transform: translate(0%, 0);
  }

  .side-leave-active .bear-container {
    transition-duration: 0.8s;
    transform: translate(0%, 0);
  }

  .load-enter .bear1-container,
  .load-enter .bear2-container,
  .side-enter .bear1-container,
  .side-leave-to .bear1-container,
  .side-enter .bear2-container,
  .side-leave-to .bear2-container {
    transform: translate(-300%, 0);
  }

  .load-enter .bear3-container,
  .load-enter .bear4-container,
  .side-enter .bear3-container,
  .side-leave-to .bear3-container,
  .side-enter .bear4-container,
  .side-leave-to .bear4-container {
    transform: translate(300%, 0);
  }
</style>

<style scoped>
  .labour-love {
    position: absolute;
    height: 8vw;
    width: auto;
    right: 1.5vw;
    bottom: 1.5vw;
    z-index: 5;
  }

  .test-btn {
    position: fixed;
    left: 15px;
    top: 15px;
    z-index: 999;
    font-family: sans-serif;
    background: #56BFCA;
    color: white;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/DonorSlide.vue